import React from "react";

function Radio({
  className = "",
  name,
  id,
  isChecked,
  onChange,
  value,
  testid,
}) {
  const handleChange = () => {
    typeof onChange === "function" && onChange(value);
  };

  return (
    <label
      className={`w-4 h-4 rounded-full flex items-center justify-center relative ${className} ${
        isChecked ? "bg-pri" : "border-grey"
      }`}
    >
      <span
        className={`${
          isChecked ? "w-1.5 h-1.5 block rounded-full bg-white absolute" : ""
        }`}
      ></span>
      <input
        type="radio"
        className="opacity-0"
        checked={isChecked}
        onChange={handleChange}
        data-testid={testid}
        {...{ name, id }}
      />
    </label>
  );
}

export default Radio;
